import React, { useState } from 'react';

/** Default brand image (overridable via REACT_APP_LOGO_URL in frontend/.env) */
const DEFAULT_LOGO_URL =
  'https://cdn.dribbble.com/userupload/16116771/file/original-4bcde75ccb57d299fae567ca3f8d96ea.png?format=webp&resize=400x300&vertical=center';

function resolveLogoUrl() {
  const fromEnv = (process.env.REACT_APP_LOGO_URL || '').trim();
  return fromEnv || DEFAULT_LOGO_URL;
}

/**
 * Farmfleet mark — remote image by default; inline SVG if image fails to load or URL empty.
 */
function FarmfleetLogoMark({ className, title }) {
  const url = resolveLogoUrl();
  const [useSvg, setUseSvg] = useState(false);

  if (!useSvg && url) {
    return (
      <img
        className={className}
        src={url}
        alt={title || ''}
        aria-hidden={title ? undefined : true}
        decoding="async"
        loading="eager"
        referrerPolicy="no-referrer"
        onError={() => setUseSvg(true)}
      />
    );
  }

  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      aria-label={title}
    >
      {title ? <title>{title}</title> : null}
      <circle cx="32" cy="32" r="28" stroke="currentColor" strokeWidth="2" fill="none" />
      <path d="M20 40 L32 24 L44 40 L32 36 Z" fill="currentColor" opacity="0.9" />
      <path d="M16 44 L32 32 L48 44" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  );
}

export default FarmfleetLogoMark;
